import { useState } from "react";
import { TextField, Button, CircularProgress } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import MarkEmailReadRoundedIcon from "@mui/icons-material/MarkEmailReadRounded";
import api from "../../../config/api";

export default function ForgotPasswordForm({ setPageType }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [devLink, setDevLink] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      // dev fallback: server returns the link when SMTP isn't configured
      if (data?.resetUrl) setDevLink(data.resetUrl);
      setSent(true);
    } catch (err) {
      setError(
        err?.response?.data?.error || err?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#f8ecd7] to-[#efdcbd] text-[#b28585] ring-1 ring-[#e0b65c]/40">
          <MarkEmailReadRoundedIcon sx={{ fontSize: 30 }} />
        </div>
        <h2 className="font-display text-3xl font-bold text-[#511d00]">
          Check your inbox
        </h2>
        <p className="mx-auto mt-2 max-w-xs text-sm text-[#8a7575]">
          If an account exists for{" "}
          <span className="font-semibold text-[#5e3e3e]">{email}</span>, we've
          sent a link to reset your password.
        </p>

        {devLink && (
          <a
            href={devLink}
            className="mt-4 inline-block w-full rounded-lg border border-dashed border-[#cba24b] bg-[#fdf6e9] px-3 py-2 text-xs font-semibold text-[#8a5a3e] hover:bg-[#f8ecd7]"
          >
            Dev: open reset link →
          </a>
        )}

        <Button
          onClick={() => setPageType("login")}
          variant="contained"
          fullWidth
          size="large"
          sx={{ mt: 2, py: 1.3, borderRadius: 2, fontWeight: 700 }}
        >
          Back to Sign In
        </Button>
      </div>
    );
  }

  return (
    <div>
      <button
        onClick={() => setPageType("login")}
        className="mb-4 inline-flex items-center gap-1 text-sm font-semibold text-[#b28585] hover:underline"
      >
        <ArrowBackRoundedIcon sx={{ fontSize: 18 }} /> Back to Sign In
      </button>

      <div className="mb-6">
        <h2 className="font-display text-3xl font-bold text-[#511d00]">
          Forgot Password?
        </h2>
        <p className="mt-1 text-sm text-[#8a7575]">
          Enter your email and we'll send you a link to reset your password.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <TextField
            id="email"
            name="email"
            label="Email"
            type="email"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && (
            <p className="text-sm font-medium text-[#c0392b]">{error}</p>
          )}
          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            disabled={loading}
            sx={{ py: 1.3, borderRadius: 2, fontWeight: 700 }}
          >
            {loading ? <CircularProgress size={22} sx={{ color: "#fff" }} /> : "Send Reset Link"}
          </Button>
        </div>
      </form>
    </div>
  );
}
